import { MdAttachEmail, MdLocalPhone } from "react-icons/md"; // 1. Added MdLocalPhone here

const data = [
  {
    contactId: 4,
    icon: <MdAttachEmail />,
    link: "mailto:edrisahmaddost@gmail.com",
  },
  {
    contactId: 5, // 2. Given a unique ID
    icon: <MdLocalPhone />, // 3. Added the phone icon component
    link: "tel:+33766363784", // 4. Your phone number here
  },
];

export default data;
